module.exports = __webpack_public_path__ + "r-v3/img/ml_12_01.59914f5e.jpg";